import React, { useEffect, useState } from 'react';
import Social from '../Social/Social';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';




const Footer = ({ data, varient }) => {
  const { logo, bgImg, links } = data;
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const [scrollPosition, setScrollPosition] = useState(0);


  const handleScroll = () => {
    const currentPosition = window.scrollY;
    setScrollPosition(currentPosition);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <footer className={`st-site-footer st-sticky-footer st-dynamic-bg ${varient ? varient : ""}`}
      style={{ backgroundImage: `url(${bgImg})`, borderTop: '1px solid #d8d8d8'}}>
      <div className="st-main-footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="st-footer-widget">
                <div className="st-text-field">
                  <img src={logo} alt={logo} className="st-footer-logo" />
                  <div className="st-height-b25 st-height-lg-b25" />
                  <div className="st-footer-text">Esperienza, passione e professionalit&agrave; al servizio della salute femminile.<br></br>Dalla prevenzione alla bellezza, offro soluzioni per ogni fase della vita.</div>
                  <div className="st-height-b25 st-height-lg-b25" />
                  <Social data={links} />
                </div>
              </div>
            </div>
            {/* .col */}
            <div className="col-lg-3">
              <div className="st-footer-widget">
                <h2 className="st-footer-widget-title">Link Utili</h2>
                <ul className="st-footer-widget-nav st-mp0">
                  <li>
                    <Link to="/privacy-policy">
                      <Icon icon="fa:angle-right" />
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/cookie-policy">
                      <Icon icon="fa:angle-right" />
                      Cookie Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="https://www.miodottore.it/rosa-coppola/ginecologo-medico-estetico/salerno">
                      <Icon icon="fa:angle-right" />
                      Presente su miodottore.it
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* .col */}
            <div className="col-lg-3">
              <div className="st-footer-widget">
                <h2 className="st-footer-widget-title">Servizi</h2>
                <ul className="st-footer-widget-nav st-mp0">
                  <li>
                    <Link to="/ginecologia">
                      <Icon icon="fa:angle-right" />
                      Ginecologia
                    </Link>
                  </li>
                  <li>
                    <Link to="/medicina-estetica">
                      <Icon icon="fa:angle-right" />
                      Medicina Estetica
                    </Link>
                  </li>
                  <li>
                    <Link to="/trattamenti-ginecologia">
                      <Icon icon="fa:angle-right" />
                      Trattamenti Ginecologia
                    </Link>
                  </li>
                  <li>
                    <Link to="servizi-estetica">
                      <Icon icon="fa:angle-right" />
                      Servizi Estetica
                    </Link>
                  </li>
                  <li>
                    <Link to="trattamenti-viso">
                      <Icon icon="fa:angle-right" />
                      Trattamenti Viso
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* .col */}
            <div className="col-lg-3">
              <div className="st-footer-widget">
                <h2 className="st-footer-widget-title">Contatti</h2>
                <ul className="st-footer-contact-list st-mp0">
                  <li>
                    <span className="st-footer-contact-title">Salerno:</span>
                    <a href="https://www.google.it/maps/place/Corso+Giuseppe+Garibaldi,+47,+84123+Salerno+SA/@40.6745343,14.768525,17z/data=!3m1!4b1!4m6!3m5!1s0x133bc23a36b0d58d:0x5bcca49bd6764779!8m2!3d40.6745343!4d14.7710999!16s%2Fg%2F11nnkqhx4v?entry=ttu&g_ep=EgoyMDI1MDQzMC4xIKXMDSoASAFQAw%3D%3D">Corso Garibaldi, 47</a>
                  </li>
                  <li>
                    <span className="st-footer-contact-title">Eboli:</span>
                    <a href="https://www.google.it/maps/place/Via+XXIV+Maggio,+9,+84025+Eboli+SA/@40.6157993,15.0531333,16z/data=!3m1!4b1!4m6!3m5!1s0x1339600cb350c227:0x9961d8b9911ba128!8m2!3d40.6157993!4d15.0557082!16s%2Fg%2F11nnk_yb_5?entry=ttu&g_ep=EgoyMDI1MDQzMC4xIKXMDSoASAFQAw%3D%3D">Via XXIV Maggio, 9</a>
                  </li>
                  <li>
                    <span className="st-footer-contact-title">Email:</span>{" "}
                    <a href="mailto:info@dottoressarosacoppola.it">info@dottoressarosacoppola.it</a>
                  </li>
                  <li>
                    <span className="st-footer-contact-title">GINECOLOGIA:</span>
                    <a href="tel:+393486927058"> 348 692 7058</a>
                  </li>
                  <li>
                    <span className="st-footer-contact-title">ESTETICA:</span>
                    <a href="tel:+393519000834"> 351 900 0834 </a>
                  </li>
                </ul>
              </div>
            </div>
            {/* .col */}
          </div>
        </div>
      </div>
      <div className="st-copyright-wrap">
        <div className="container">
          <div className="st-copyright-in">
            <div className="st-left-copyright">
              <div className="st-copyright-text">
                Copyright ©️ {currentYear} Dottoressa Rosa Coppola | Developed by <a href="https://www.gennaroreawd.it/">Gennaro Rea - Web Developer</a>
              </div>
            </div>
            <div className="st-right-copyright">
              <div id="st-backtotop" style={{ scale: `${scrollPosition >= 100 ? "1" : "0"}` }} onClick={scrollToTop}>
                <Icon icon="fa6-solid:angle-up" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
